/* Italian Secret, 2026-10-12: Capture and scrub the personal invitation before third-party scripts load. */
(() => {
  'use strict';
  const params = new URLSearchParams(location.hash.slice(1));
  let token = params.get('sample-invitation');
  const present = token !== null;
  if (!present) return;
  // No token in page URLs, analytics, referrers, storage or activity webhooks.
  history.replaceState(history.state, '', location.pathname + location.search + '#order');
  let pending;
  window.PizzaInvitation = {
    present,
    discard() { token = null; },
    resolve(publicId) {
      if (pending) return pending;
      if (!token || !/^[A-Za-z0-9_-]{43}$/.test(token) || !/^[A-Za-z0-9_-]{32}$/.test(publicId || '')) return Promise.resolve(null);
      const credential = token; token = null;
      pending = (async () => {
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch('/apps/prometheus-subscriptions/sample-campaign/prefill', {
            method: 'POST', credentials: 'same-origin', referrerPolicy: 'no-referrer', cache: 'no-store', signal: controller.signal,
            headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ payload: JSON.stringify({ publicId, token: credential }) })
          });
          if (!response.ok) return null;
          const result = await response.json();
          if (result.verified !== true || !result.contact || typeof result.contact !== 'object') return null;
          const contact = {};
          for (const [key, max] of Object.entries({ name: 100, business: 150, email: 254, phone: 40 })) {
            const value = result.contact[key];
            if (typeof value !== 'string' || value.length > max) return null;
            contact[key] = value;
          }
          return contact;
        } catch { return null; }
        finally { clearTimeout(timer); }
      })();
      return pending;
    }
  };
})();
